import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  VERIFY_INFO: `${cleanedFilename(__filename)}-verify-info`,
  VERIFY_FORM: `${cleanedFilename(__filename)}-verify-form`,
  SUBMIT_BUTTON: `${cleanedFilename(__filename)}-submit-button`,
  RESEND_CODE_BUTTON: `${cleanedFilename(__filename)}-resend-code-button`,
};
